import { createApp } from "vue";
import Toast, { useToast, POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

const options = {
  position: POSITION.TOP_LEFT,
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.3,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  rtl: localStorage.getItem("MEMO:LANG") == "ar" ? true : false,
  transition: "Vue-Toastification__slideBlurred",
};

const toastApp = createApp({});
toastApp.use(Toast, options);

const toastInstance = useToast();

export default function toast(message, customOptions = {}) {
  toastInstance(message, { ...options, ...customOptions });
}
